<template>
  <swiper-slide class="swiper_newpage5">
  </swiper-slide>
</template>
  <script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "newpage5",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
    };
  },
};
</script>
  <style lang="less" scoped>
.swiper_newpage5{
    width: 100% !important;
  height: 100%;
  background: url("../assets/newpagebg5.jpg") no-repeat;
  background-size: 100% 100%;
}
</style>